import React from 'react';
import {Typography} from 'antd';
import {Car} from '../../types/carTypes';

import './CarDetailsHeader.less';

const { Text } = Typography;

const CarDetailsHeader = ({ car } : { car? : Partial<Car>}) => {
    const carNumber = car?.number;
    const carDescription = car?.deployable_description;
    const locationDescription = car?.location_description || 'No current location';

    return (
        <>
            <Text className="car-number">Vehicle #{carNumber}</Text>
            <Text strong className="car-description">{carDescription}</Text>
            <Text className="location-description">{locationDescription}</Text>
        </>
    );
};

export default CarDetailsHeader;
